import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "locked"
const LockedIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 14.25C12.828 14.25 13.5 14.922 13.5 15.75S12.828 17.25 12 17.25 10.5 16.578 10.5 15.75 11.172 14.25 12 14.25" />
          <path
            fillRule="evenodd"
            d="M17.25 9.505C18.952 9.91 19.493 10.414 19.5 10.42V21L19.492 21.153C19.42 21.86 18.859 22.42 18.153 22.492L18 22.5H6C5.172 22.5 4.5 21.828 4.5 21V10.42C4.507 10.415 5.048 9.91 6.75 9.506V6.75C6.75 5.358 7.303 4.022 8.287 3.037 9.272 2.053 10.607 1.5 12 1.5 13.392 1.5 14.728 2.053 15.713 3.037 16.697 4.022 17.25 5.357 17.25 6.75zM8.25 9.229C9.242 9.092 10.476 9 12 9S14.758 9.092 15.75 9.229V6.75C15.75 5.755 15.355 4.802 14.651 4.099 13.948 3.395 12.995 3 12 3S10.052 3.395 9.349 4.099C8.645 4.802 8.25 5.755 8.25 6.75zM12 10.5C9.114 10.5 7.397 10.842 6.452 11.14Q6.187 11.227 6 11.303V21H18V11.302Q17.813 11.226 17.548 11.141C16.603 10.842 14.886 10.5 12 10.5"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default LockedIcon
